import { SupplierResponseDto } from "../shared/dtos/supplier/SupplierResponseDto";
import { SupplierSummaryDto } from "../shared/dtos/supplier/SupplierSummaryDto";

export class SupplierMapper {
  public static mapToSummary(
    supplier: SupplierResponseDto,
  ): SupplierSummaryDto {
    return {
      id: supplier.id,
      name: supplier.name,
      supplierCode: supplier.supplierCode,
      taxId: supplier.taxId,
      primaryPhone: supplier.primaryPhone,
      email: supplier.email,
      website: supplier.website,
      createdAt: supplier.createdAt,
      updatedAt: supplier.updatedAt,
    };
  }
}
